export const buildImageUrl = (lessonId, filename) =>
    `/static/lessons/${lessonId}/img/${filename}`;

export const buildExampleUrl = (lessonId, filename) => {
    const finalFilename = filename.endsWith('.sb3') ? filename : `${filename}.sb3`;
    return `/static/lessons/${lessonId}/example/${finalFilename}`;
};